if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      
      this.template = window.getQueryParam('view');
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.addOn = this.form.dataset.addOn;
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    addItemToCart(id, quantity, properties) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id,
            quantity,
            properties
          }]
        })
      })
      .then(response => response.json())
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const itemId = formData.get('product-id');
      const itemSellingPlan = formData.get('selling_plan');
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      if (this.addOn) {
        await this.addItemToCart(this.addOn, formData.get('quantity'), { _promo: 'add_on_gift' });
      }

      if (this.template === 'nc-27') {
        await window.postData('/cart/update.js', {
          attributes: {
            '_ltd_selling_plans': 'true',
          }
        });
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

					// TryNow: Redirect to checkout after adding to cart
					const gatedToggleEl = document.querySelector('gated-flow-toggle')
					const toggleEl = document.querySelector('gated-flow-toggle input[type="checkbox"]')

					if (gatedToggleEl && toggleEl) {
						const isToggleHidden = window.getComputedStyle(gatedToggleEl).display === 'none'
						if (!isToggleHidden && toggleEl.checked) {
							this.addItemToCart('43518107385908', 1).then(() => {
								window.location.href = '/checkout'
							})
							return
						}
					}

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .then(() => {
          const selector = `.upsell-modal[data-trigger-product="${itemId}"][data-variant="${itemSellingPlan ? 'subscription' : 'one-time'}"]`;
          const $crossSellModal = document.querySelector(selector);
          if ($crossSellModal) {
            $crossSellModal.classList.add('upsell-modal--open');
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

					// Try Now code (start)
					document.querySelector('input[name="selling_plan"]')?.remove()
					// TryNow code (end)
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });

}